// Event Bus
import EventBus from "@/app/bus/event-bus.js"

// Components
import DatePicker from "vue2-datepicker"
const ModalPuppyPurchaseRefund = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "modal-puppy-purchase-refund"*/ "@/app/views/main-view/purchases/containers/puppy-purchase/puppy-purchase-details-container/modals/modal-puppy-purchase-refund/modal-puppy-purchase-refund.vue"
	)

// Mixins
import { dateMixins } from "@/app/mixins/utils/date-mixins"
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins.js"
import { inputTextMixins } from "@/app/mixins/utils/input-text-mixins"

// Constants
import { PUPPY_SELL_STATUS, STATUS_CODES } from "@/app/constants/status-constants"

// Services
import puppySellService from "@/app/services/main/puppy-sell/puppy-sell-service.js"
import paymentService from "@/app/apis/main/payment/payment-api.js"

export default {
	name: "PuppyPurchaseDetailsContainer",
	components: { DatePicker, ModalPuppyPurchaseRefund },
	mixins: [toastMessageMixins, inputTextMixins, dateMixins],
	data() {
		return {
			// List
			orderDetails: {
				status: "",
				referenceNo: "",
				shippingAddress: {
					address: "",
				},
				billingAddress: {
					address: "",
				},
			},
			genderList: [
				{ name: "Male", value: "M" },
				{ name: "Female", value: "F" },
			],
			theads: [
				{ name: "Payment Method", sortLabel: null, isDesc: false, style: null },
				{ name: "Status", sortLabel: null, isDesc: false, style: null },
				{ name: "Message", sortLabel: null, isDesc: false, style: null },
				{ name: "Price", sortLabel: null, isDesc: false, style: null },
			],
			// Loader
			isAPILoading: false,

			// Puppy Details
			puppySellId: null,
			breedName: "",
			birthDate: "",
			gender: "",
			colour: "",
			microchipNumber: "",
			puppyReferenceNumber: "",
			puppyStatus: "",
			puppyName: "",
			// Breeder Details
			breederId: "",
			breederName: "",
			breederMobile: "",
			breederStatus: "",
			mobileNumberIsValid: true,
			breederEmail: "",
			pickupDate: "",
			state: "",

			// Order Details
			referenceNo: "",
			orderDate: "",
			recipientName: "",
			recipientEmail: "",
			recipientMobileNo: "",

			// Transaction History
			transactionHistory: [],

			// Prices
			storeCredit: 0.0,
			price: "0.00",

			// Others
			reason: "",
			isDetailsUpdated: false,
		}
	},

	created() {
		this.checkRoute();
	},
	watch: {
		$route: {
			handler() {
				this.checkRoute();
			},
			deep: true,
		},
	},
	
	computed: {
		totalPrice() {
			return parseFloat(this.storeCredit) + parseFloat(this.price)
		},
		statusColor() {
			const statusMap = {
				["A"]: "status--green",
				["PICKED_UP"]: "status--green",
				["P"]: "status--blue",
				["REQUEST_REFUND"]: "status--blue",
				["S"]: "status--grey",
				["REFUNDED"]: "status--grey",
				["CANCELED"]: "status--red",
				["D"]: "status--red",
			}

			return statusMap[this.puppyStatus] || "status--grey"
		},
		statusDisplay() {
			return PUPPY_SELL_STATUS[this.puppyStatus]
		},
	},

	methods: {
		checkRoute() {
			this.getPuppyPurchaseDetails(this.$route.params.id);
	  	},
		async getPuppyPurchaseDetails(id) {
			this.isAPILoading = true
			try {
				const response = await puppySellService.getPuppyPurchasedDescription(id)
				if (response.status === STATUS_CODES.SUCCESS) {
					const breederDetails = response.data.breeder
					const puppyDetails = response.data.puppyDetails
					const buyerDetails = response.data.buyerDetails
					const payment = response.data.payment
					const transactionHistory = response.data.transactionHistory

					// Puppy Details
					this.puppySellId = puppyDetails.id
					this.breedName = puppyDetails.breedName
					this.birthDate = this.formatDate(puppyDetails.birthdate)
					this.gender = puppyDetails.gender === "M" ? "Male" : "Female"
					this.puppyName = puppyDetails.puppyName ? puppyDetails.puppyName : "Puppy Name"
					this.colour = puppyDetails.colour
					this.microchipNumber = puppyDetails.microchipNumber
					this.puppyReferenceNumber = puppyDetails.puppyReferenceNumber
					this.puppyStatus = puppyDetails.status

					// Breeder Details
					this.breederId = breederDetails.code
					this.breederName = breederDetails.name
					this.breederEmail = breederDetails.email
					this.breederMobile = breederDetails.mobileNumber
					this.breederStatus =  breederDetails.status
					this.state = breederDetails.state

					// Order Details
					this.referenceNo = buyerDetails.referenceNumber
					this.orderDetails.status = puppyDetails.status
					this.orderDetails.referenceNo = buyerDetails.referenceNumber
					this.orderDate = this.formatDate(buyerDetails.createdAt)
					this.recipientName = buyerDetails.recipientName
					this.recipientEmail = buyerDetails.email
					this.recipientMobileNo = buyerDetails.mobileNumber
					this.price = puppyDetails.price
					this.storeCredit = buyerDetails.storeCredit || 0.0

					// Addresses
					this.orderDetails.shippingAddress.address = buyerDetails.shippingAddress.address
					this.orderDetails.billingAddress.address = buyerDetails.billingAddress.address

					//Payment
					this.orderDetails.payment = payment

					// Transaction History
					this.transactionHistory = transactionHistory
				} else if (response.status === STATUS_CODES.UNAUTHORIZED ||
					response.status === STATUS_CODES.NOT_FOUND
				) {
					EventBus.$emit('errorUnAuthorizeUser', true);
				}else {
					this.showAPIErrorToast(`Unable to get Puppy Purchase Details.`, res)
				}
				this.isAPILoading = false
			} catch (error) {
				this.showGenericErrorToast()
				this.isAPILoading = false
			}
		},

		mobileFormat(mobileNumber) {
			if (mobileNumber) {
				let data = mobileNumber.split("")
				data.splice(4, 0, "-")
				return data.join("")
			} else {
				return ""
			}
		},

		puppyPurchasedStatusColor(status) {
			const statusMap = {
				["A"]: "status--green",
				["PICKED_UP"]: "status--green",
				["PP"]: "status--blue",
				["REQUEST_REFUND"]: "status--blue",
				["S"]: "status--grey",
				["REFUNDED"]: "status--grey",
				["CANCELED"]: "status--red",
				["DECLINED"]: "status--red",
			}

			return statusMap[status] || "status--grey"
		},

		showRefundDropdown(status) {
			return ["REQUEST_REFUND", "REFUNDED", "PICKED_UP", "HIDDEN"].includes(status)
		},

		async requestForRefund() {
			this.$refs.modalRefund.openModal(this.orderDetails)
		},
		cancelRequest() {
			this.$swal({
				title: `CANCEL REQUEST`,
				html: `Are you sure you want to cancel this puppy purchase?`,
				confirmButtonText: "Confirm",
				showCancelButton: true,
				cancelButtonText: "Cancel",
				reverseButtons: true,
			}).then((result) => {
				if (result.value) {
					this.isAPILoading = true
					puppySellService
						.cancelPuppyPurchase(this.$route.params.id)
						.then((res) => {
							if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
								this.showCustomSuccessToast(null, `Puppy purchase request has been cancelled!`)
								this.$router.push("/purchases")
							} else {
								this.showAPIErrorToast(`Unable to cancel puppy purchase request.`, res)
							}
						})
						.catch(() => {
							this.showGenericErrorToast()
						})
						.finally(() => {
							this.isAPILoading = false
						})
				}
			})
		},

		proceedToPayment() {
			try {
				paymentService.getLatitudeInterestFreeUrlForProductPurchase(this.$route.params.id).then((res) => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.redirectToLpInterestFree(res.data.redirectUrl)
					} else {
						this.showAPIErrorToast("", res)
					}
				})
			} catch (error) {
				this.showGenericErrorToast()
			}
		},

		redirectToLpInterestFree(url) {
			const latitudeInterestFreeImg = require("@/assets/images/_shared/latitude-interest-free-logo.svg")
			this.$swal({
				title: "Redirecting to ...",
				html: `<img style='width: 300px' src=${latitudeInterestFreeImg}>`,
				allowOutsideClick: false,
				timer: 2000,
				showCancelButton: false,
				showConfirmButton: false,
			}).then(() => {
				window.location = url
			})
		},

		timelineItems() {
			let items = [];
			if (this.orderDetails && this.transactionHistory) {
				for (const data of this.transactionHistory) {
					const { date, status, remarks, submittedBy } = data;

					let transDate = this.formatDateTime(date);
					let content = PUPPY_SELL_STATUS[status]
						? PUPPY_SELL_STATUS[status]
						: status;

					if (status === "RR") {
						content += `<br> <p class="color-warning mb-0">Reason: ${remarks}</p>`;
						content += `<p class="color-warning mb-0">Verified By: ${submittedBy}</p>`;
					} else if (status === "FP" && submittedBy) {
						content += `<br> <p class="color-warning mb-0">${remarks}</p>`;
						content += `<p class="color-warning mb-0">Verified By: ${submittedBy}</p>`;
					} else if (status === "R") {
						content += `<br> <p class="color-warning mb-0">${remarks}</p>`;
						content += `<p class="color-warning mb-0">Approved By: ${submittedBy}</p>`;
					} else if (status === "REQUEST_REFUND" && remarks != "" && remarks) {
						content += `<br> <p class="color-warning mb-0">Reason: ${remarks}</p>`
						content += `<p class="color-warning mb-0">Submitted By: ${submittedBy}</p>`
					} else if (status === "DISAPPROVED_REFUND" && submittedBy) {
						// DISAPPROVED REFUND 
						content += `<br> <p class="color-warning mb-0">Reason: ${remarks}</p>`;
						content += `<p class="color-warning mb-0">Verified By: ${submittedBy}</p>`;
					} else if (status === "PENDING PAYMENT") {
						content += `<p class="color-warning mb-0">Submitted By: ${submittedBy}</p>`
					} else if (status === "S" && !!remarks && !!submittedBy) {
						// S - SOLD
						content += `<br> <p class="color-warning mb-0">Remarks: ${remarks}</p>`
						content += `<p class="color-warning mb-0">Verified By: ${submittedBy}</p>`
					} else if ((status === "A" && submittedBy) || (status === PUPPY_SELL_STATUS.HIDDEN && submittedBy)) {
						// A - Available
						content += `<br> <p class="color-warning mb-0">Remarks: ${remarks}</p>`
						content += `<p class="color-warning mb-0">Submitted By: ${submittedBy}</p>`
					} else if (status === "F" && submittedBy) {
						// F - FAILED
						content += `<br> <p class="color-warning mb-0">Remarks: ${remarks}</p>`
						content += `<p class="color-warning mb-0">Verified By: ${submittedBy}</p>`
					} else if (status === "PICKED_UP" && submittedBy) {
						content += `<p class="color-warning mb-0">Verified By: ${submittedBy}</p>`
					} else if (status === "REFUNDED") {
						content += `<br> <p class="color-warning mb-0">${remarks}</p>`
						content += `<p class="color-warning mb-0">Approved By: ${submittedBy}</p>`
					}
					 else if (submittedBy) {
						content += `<br> <p class="color-warning mb-0">Submitted By: ${submittedBy}</p>`;
					}else if (status === "S" && !!remarks) {
						// S - SOLD
						content += `<br> <p class="color-warning mb-0">Remarks: ${remarks}</p>`
					} 

					items.push({
						htmlMode: true,
						content: `[${transDate}] : ${content}`,
					});
				}
			}

			return items;
		},
	},
}
